




import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class Trigger extends Vue {
  observer: IntersectionObserver | null = null;
  options: IntersectionObserverInit = {
    root: null,
    threshold: 0
  };

  mounted() {
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.$emit('triggerIntersected');
      }
    }, this.options);

    this.observer.observe(this.$refs.trigger as HTMLElement);
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }
}
